import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const FAQs = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = "078527878"; // Replace with your WhatsApp number
    const message = encodeURIComponent("Hello, I have a question regarding your services.");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  return (
    <>
      <Navbar />
      <Container className="py-5">
        <h2 className="text-center mb-4">Frequently Asked Questions</h2>

        <Card className="p-4 shadow-lg">
          <h3 className="text-2xl font-semibold text-gray-800 text-center mb-4">General Questions</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {[
              { question: "What is the eligibility for a loan?", answer: "You must be an active member with a minimum deposit of Ksh 2,000." },
              { question: "How long does loan approval take?", answer: "Loan approval takes 24-48 hours upon submission of all required documents." },
              { question: "What documents are required for loan application?", answer: "You need a copy of your ID, recent payslips, and signed loan forms." },
              { question: "Can I apply for multiple loans at once?", answer: "Yes, but the total amount must not exceed your eligible limit." }
            ].map((faq, index) => (
              <div key={index} className="p-6 bg-white rounded-lg shadow-lg">
                <h4 className="text-xl font-semibold text-gray-800">{faq.question}</h4>
                <p className="text-gray-600 mt-2">{faq.answer}</p>
              </div>
            ))}
          </div>
        </Card>

        <Card className="p-4 mt-5 shadow-lg">
          <h3 className="text-2xl font-semibold text-gray-800 text-center mb-4">Savings & Withdrawals</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {[
              { question: "Can I withdraw my savings anytime?", answer: "Only withdrawable savings can be accessed anytime. Fixed deposits follow their agreed timeline." },
              { question: "What interest rate do savings earn?", answer: "The interest rate for savings is 8% per annum, compounded monthly." },
              { question: "How do I check my account balance?", answer: "You can check your balance via the mobile app or by visiting our offices." },
              { question: "What happens if I stop contributing?", answer: "Your account remains active, but you may not qualify for loans without regular contributions." }
            ].map((faq, index) => (
              <div key={index} className="p-6 bg-white rounded-lg shadow-lg">
                <h4 className="text-xl font-semibold text-gray-800">{faq.question}</h4>
                <p className="text-gray-600 mt-2">{faq.answer}</p>
              </div>
            ))}
          </div>
        </Card>

        {/* Ask Now Button */}
        <div className="text-center mt-5">
          <Button
            className="bg-green-500 text-white px-4 py-2 rounded-md text-lg shadow-md hover:bg-green-600 transition-all"
            onClick={handleWhatsAppClick}
          >
            📲 Ask Now
          </Button>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default FAQs;
